module.exports = __webpack_public_path__ + "static/img/banner.bf0c901d.jpg";